import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useNavigate, useLocation } from 'react-router-dom';
import Home from './pages/Home';
import Navbar from './components/Navbar';
import LoginModal from './components/LoginModal';
import SignupModal from './components/SignupModal';
import DetectorApp from './pages/DetectorApp';
import Admin from "./pages/Admin";
import UsersPage from "./pages/userspage";
import FeedbackPage from "./pages/feedbackpage";
import ViewInputPage from './pages/viewinputpage';
import AdminDetector from "./pages/AdminDetector";
import AdminManage from "./pages/AdminManage";
import GoogleSetPassword from "./pages/GoogleSetPassword";
import GooglePasswordCheck from "./pages/GooglePasswordCheck";

// Redirects to home if regular user is not logged in
function ProtectedRoute({ children }) {
  const isLoggedIn =
    !!localStorage.getItem("token") ||
    !!localStorage.getItem("userEmail") ||
    !!localStorage.getItem("adminEmail") ||
    !!localStorage.getItem("googleEmail");
  return isLoggedIn ? children : <Navigate to="/" replace />;
}

// Redirects to home if user is not a logged-in admin
function ProtectedAdminRoute({ children }) {
  const isAdmin = !!localStorage.getItem("adminEmail");
  return isAdmin ? children : <Navigate to="/" replace />;
}

function AppContent() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [showSignup, setShowSignup] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(!!localStorage.getItem("userEmail"));

  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const handleLogin = () => setIsLoggedIn(true);
    const handleLogout = () => setIsLoggedIn(false);

    window.addEventListener("userLoggedIn", handleLogin);
    window.addEventListener("userLoggedOut", handleLogout);

    return () => {
      window.removeEventListener("userLoggedIn", handleLogin);
      window.removeEventListener("userLoggedOut", handleLogout);
    };
  }, []);

  const handleSuccessfulLogin = (role) => {
    setIsModalOpen(false);
    setShowSignup(false);
    setIsLoggedIn(true);

    if (role === 'User') navigate('/DetectorApp');
    if (role === 'Admin') navigate('/admin');
  };

  const handleLoginClick = () => setIsModalOpen(true);
  const handleHomeClick = () => navigate('/');

  const hideNavbar = location.pathname.startsWith('/admin');

  return (
    <>
      {!hideNavbar && (
        <Navbar
          onLoginClick={handleLoginClick}
          onHomeClick={handleHomeClick}
          isLoggedIn={isLoggedIn}
        />
      )}

      <Routes>
        <Route path="/" element={<Home onLoginClick={handleLoginClick} />} />
        <Route
          path="/DetectorApp"
          element={
            <ProtectedRoute>
              <DetectorApp />
            </ProtectedRoute>
          }
        />
        <Route path="/admin" element={<ProtectedAdminRoute><Admin /></ProtectedAdminRoute>} />
        <Route path="/admin/users" element={<ProtectedAdminRoute><UsersPage /></ProtectedAdminRoute>} />
        <Route path="/admin/feedback" element={<ProtectedAdminRoute><FeedbackPage /></ProtectedAdminRoute>} />
        <Route path="/view-input/:id" element={<ProtectedAdminRoute><ViewInputPage /></ProtectedAdminRoute>} />
        <Route path="/admin/detector" element={<ProtectedAdminRoute><AdminDetector /></ProtectedAdminRoute>} />
        <Route path="/admin/manage" element={<ProtectedAdminRoute><AdminManage /></ProtectedAdminRoute>} />
        <Route path="/signup-google" element={<GoogleSetPassword />} />
        <Route path="/google-password-check" element={<GooglePasswordCheck />} />
      </Routes>

      {isModalOpen && (
        <LoginModal
          onClose={() => setIsModalOpen(false)}
          onLoginSuccess={handleSuccessfulLogin}
          openSignup={() => {
            setIsModalOpen(false);
            setShowSignup(true);
          }}
        />
      )}

      {showSignup && (
        <SignupModal
          onClose={() => setShowSignup(false)}
          openLogin={() => {
            setShowSignup(false);
            setIsModalOpen(true);
          }}
        />
      )}
    </>
  );
}

export default function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}